/**
 * @fileoverview POST handler for the "/apps/:app_group_id/analytics_report_setting" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdAnalyticsReportSettingCacheKeys } from "./constants";
import type {
  PostAppsAppGroupIdAnalyticsReportSettingProps,
  AppsAppGroupIdAnalyticsReportSettingResult,
} from "./types";
import { appSettingsCustomEventsData } from "@dashboardApi/apis/appSettingsCustomEventsData";

export const postAppsAppGroupIdAnalyticsReportSetting = reactQueryMutationAdapter(
  [appSettingsCustomEventsData, appsAppGroupIdAnalyticsReportSettingCacheKeys],
  (props: PostAppsAppGroupIdAnalyticsReportSettingProps): Promise<AppsAppGroupIdAnalyticsReportSettingResult> => {
    const { appGroupId, ...request } = props;
    return fetch(`/apps/${appGroupId}/analytics_report_setting`, "POST", request);
  }
);
